export default schoolClass => {
  return `${schoolClass.className} клас ${schoolClass.isExternat ? 
    'екстернат' : schoolClass.isCourse ? 
    'факультатив' : ''}`;
}